import { render, staticRenderFns } from "./MainTabBar.vue?vue&type=template&id=654d598d"
import script from "./MainTabBar.vue?vue&type=script&lang=js"
export * from "./MainTabBar.vue?vue&type=script&lang=js"
import style0 from "./MainTabBar.vue?vue&type=style&index=0&id=654d598d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports